import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxChangeAlertsList } from "../../Apis/AuthApiServices";
import {
  loadingRxChangeAlertsDetails,
  setRxChangeAlertsDetails,
} from "../Slice/RxChangeAlertsDetailsSlice";

function* onLoadRxChangeAlertsDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("selectedDoctorId", payload.docId);
  try {
    const result: AxiosResponse = yield RxChangeAlertsList(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxChangeAlertsDetails({
          RxChangeAlertsDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxChangeAlertsDetails({
          RxChangeAlertsDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxChangeAlertsDetails({
        RxChangeAlertsDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxChangeAlertsDetails() {
  yield takeLatest(
    loadingRxChangeAlertsDetails.type,
    onLoadRxChangeAlertsDetailsAsync
  );
}

const RxChangeAlertsDetailsSaga = [fork(onLoadRxChangeAlertsDetails)];
export default RxChangeAlertsDetailsSaga;
